import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Icon, Input, Checkbox} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {validateErrorsAreas} from '../../utils';

const {addNewLogisticArea, addMessageBoxError, updateLogisticArea} = Actions;

const AreaFormInput = ({
  id,
  addArea,
  cancelAddArea,
  areaForm,
  setAreaForm,
  setEditArea,
  loadingDetail,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (addArea) {
      setEditArea('');
      setAreaForm({'primaryCode': '', 'description': '', 'status': 'I'});
    }
  }, [addArea]);

  const cancelAddOrEdit = () => {
    cancelAddArea();
    setAreaForm({'status': 'I'});
    setEditArea('');
  };

  const saveArea = async() => {
    const {error, message} = validateErrorsAreas(areaForm);

    if (error) {
      dispatch(addMessageBoxError(message));
    } else if (addArea) {
      dispatch(addNewLogisticArea(areaForm));
    } else {
      const {primaryCode, secondaryCode} = areaForm;
      await dispatch(updateLogisticArea({primaryCode, secondaryCode}, areaForm));
    }
    cancelAddOrEdit();
  };

  const onChangeInputValue = (e, {name, value}) => {
    let finalValue = value.toUpperCase();
    if (name === 'status') {
      finalValue = value === 'I' ? 'A' : 'I';
    }
    setAreaForm({...areaForm, [name]: finalValue});
  };

  if (id === 'status') {
    return (
      <Checkbox
        toggle
        name={id}
        value={areaForm[id]}
        onChange={onChangeInputValue}
        checked={areaForm[id] === 'A'}
      />
    );
  }
  if (id !== 'actions') {
    return (
      <Input
        required
        disabled={loadingDetail || (!addArea && id !== 'description')}
        value={areaForm[id]}
        name={id}
        onChange={onChangeInputValue}
      />
    );
  }
  return (
    <>
      <Icon name="save" color="green" link size="big" disabled={loadingDetail} onClick={saveArea} />
      <Icon
        name="cancel"
        color="red"
        disabled={loadingDetail}
        link
        size="big"
        onClick={cancelAddOrEdit}
      />
    </>
  );
};


export default AreaFormInput;
